import { render, staticRenderFns } from "./LanguageSettingsNavBar.vue?vue&type=template&id=643ebc5c&"
import script from "./LanguageSettingsNavBar.vue?vue&type=script&lang=js&"
export * from "./LanguageSettingsNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports